import { gql } from '@apollo/client';

export const GENERATE_AVV = gql`
  mutation GenerateAVV($avvData: AVVDataInput!) {
    generateAVV(avvData: $avvData) {
      success
      result {
        id
        downloadUrl
        fileName
      }
      error
    }
  }
`; 